@if (hasInwardStops || hasOutwardStops) {
  <div class="wrapper" [class.dark]="darkMode">
    <div class="details-wrapper">
      <a
        class="show-details-link"
        (click)="showDetails = !showDetails"
        (keydown.enter)="showDetails = !showDetails"
        tabindex="0"
        role="button"
        [attr.aria-expanded]="showDetails"
      >
        <span i18n="@@basketPanelTotalShowDetails">Show details</span>
        <span class="sr-only">
          - {{ panelSummary.departureStationName }} <span i18n="@@to">to</span>
          {{ panelSummary.arrivalStationName }} {{ panelSummary.departureDateTime | sabsDate: 1 }}
          {{ panelSummary.departureDateTime | sabsTimePipe: 'timeString' }}
        </span>
        <i
          class="ico"
          [class.ico-chevron-down]="!showDetails"
          [class.ico-chevron-up]="showDetails"
          aria-hidden="true"
        ></i>
      </a>
      @if (showDetails) {
        <div class="summary">
          @if (hasOutwardStops) {
            <div class="summary-header">
              <div>
                {{ railOutwardSummary.departureStationName }} <span i18n="@@to">to</span>
                {{ railOutwardSummary.arrivalStationName }}
              </div>
              <div>
                {{
                  totalTimeJourney(
                    railOutwardSummary.departureDateTime,
                    railOutwardSummary.arrivalDateTime
                  )
                }}
              </div>
            </div>
            @for (stop of railOutwardStops; track stop; let index = $index) {
              <div class="stops">
                @if (getSeats(index, 'outward'); as seats) {
                  <div><span i18n="@@Seat(s)">Seat(s)</span>: {{ seats }}</div>
                }
                @if (!stop.callingPoints.length) {
                  <ul>
                    <li>
                      @if (!hideCallingPointTime) {
                        <div class="time">
                          {{ stop.departDateTime | sabsTimePipe: 'timeString' }}
                        </div>
                      }
                      <div class="location">{{ stop.depart }}</div>
                    </li>
                    <li>
                      @if (!hideCallingPointTime) {
                        <div class="time">
                          {{ stop.arriveDateTime | sabsTimePipe: 'timeString' }}
                        </div>
                      }
                      <div class="location">{{ stop.arrive }}</div>
                    </li>
                  </ul>
                }
                @if (stop.callingPoints.length) {
                  <ul>
                    @for (leg of stop.callingPoints; track leg; let first = $first) {
                      <li>
                        @if (!hideCallingPointTime) {
                          <div class="time">
                            {{
                              leg.arrivalDateTime && !first
                                ? (leg.arrivalDateTime | sabsTimePipe: 'timeString')
                                : (leg.departureDateTime | sabsTimePipe: 'timeString')
                            }}
                          </div>
                        }
                        <div class="location">{{ leg.stationName }}</div>
                      </li>
                    }
                  </ul>
                }
              </div>
            }
          }
          @if (hasInwardStops) {
            <div class="summary-header">
              <div>
                {{ railInwardSummary.departureStationName }}
                <span i18n="@@railBasketPanelDetailsTo">To</span>
                {{ railInwardSummary.arrivalStationName }}
              </div>
              <div>
                {{
                  totalTimeJourney(
                    railInwardSummary.departureDateTime,
                    railInwardSummary.arrivalDateTime
                  )
                }}
              </div>
            </div>
            @for (stop of railInwardStops; track stop; let index = $index) {
              <div>
                @if (getSeats(index, 'inward'); as seats) {
                  <div><span i18n="@@Seat(s)">Seat(s)</span>: {{ seats }}</div>
                }
                @if (!stop.callingPoints.length) {
                  <ul>
                    <li>
                      @if (!hideCallingPointTime) {
                        <div class="time">
                          {{ stop.departDateTime | sabsTimePipe: 'timeString' }}
                        </div>
                      }
                      <div class="location">{{ stop.depart }}</div>
                    </li>
                    <li>
                      @if (!hideCallingPointTime) {
                        <div class="time">
                          {{ stop.arriveDateTime | sabsTimePipe: 'timeString' }}
                        </div>
                      }
                      <div class="location">{{ stop.arrive }}</div>
                    </li>
                  </ul>
                }
                @if (stop.callingPoints.length) {
                  <ul>
                    @for (leg of stop.callingPoints; track leg; let first = $first) {
                      <li>
                        @if (!hideCallingPointTime) {
                          <div class="time">
                            {{
                              leg.arrivalDateTime && !first
                                ? (leg.arrivalDateTime | sabsTimePipe: 'timeString')
                                : (leg.departureDateTime | sabsTimePipe: 'timeString')
                            }}
                          </div>
                        }
                        <div class="location">{{ leg.stationName }}</div>
                      </li>
                    }
                  </ul>
                }
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
}
